export default "__VITE_ASSET__5488df81__"